import { Injectable } from '@angular/core'
import { RestApiService } from '../rest-api/rest-api.service'
import { APIS, SCREEN_NAMES } from '../../shared-components/constants'

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(public RestApiService: RestApiService) {}

  /* --------------------------------------     New Remittance API LIST  ---------------------------------------------- */
  getExportDetails(value, data) {
    const requestUrl = `Validations/fetchAllDeductions/v2?export_screenname=${value.screenname}&export_filename=${value.filename}`
    return this.RestApiService.post_Api(requestUrl, data)
  }

  getPaymentInvoiceDetails(value) {
    return this.RestApiService.post_Api('NewPayments/fetchInvoices', value)
  }

  getInvoiceLineItemsDetails(value) {
    return this.RestApiService.post_Api(
      'LineItems/fetchInvoiceLineItems',
      value
    )
  }

  getLineItemsSummary(invoiceID, exportType?: string) {
    let requestUrl = APIS.LINE_ITEMS_SUMMARY + '?invoice_id=' + invoiceID

    if (exportType === 'export') {
      requestUrl += '&export_screenname=' + SCREEN_NAMES.LINE_ITEMS_SUMMARY
      return this.RestApiService.get_API_Export(requestUrl)
    }

    return this.RestApiService.get_API_New(requestUrl)
  }

  updateInvoiceLineItemsDetails(value) {
    return this.RestApiService.post_Api('LineItems/bulkUpdate', value)
  }

  getDeductionHeaderData(value, additionalUrlParams?) {
    let urlParams = additionalUrlParams || ''
    if (urlParams.startsWith('&')) {
      urlParams = '?' + urlParams.substring(1)
    }
    return this.RestApiService.post_Api(
      'Validations/deductionHeader/v2' + urlParams,
      value
    )
  }
  /* --------------------------------------  INVOICE API LIST  ---------------------------------------------- */

  getInvoiceDetails(value) {
    return this.RestApiService.post_Api('Validations/fetchAllDeductions', value)
  }

  addNewPromotions(data) {
    return this.RestApiService.post_Api('promotions/add', data)
  }
  getTableDataForPagination(
    requestURl?,
    value?,
    screenName?,
    additionalUrlParams?
  ) {
    if (
      screenName === SCREEN_NAMES.INVOICE_SUMMARY ||
      screenName === SCREEN_NAMES.VALIDATIONS ||
      screenName === SCREEN_NAMES.AWAITING_APPROVAL ||
      screenName === SCREEN_NAMES.APPROVED_DEDUCTIONS ||
      screenName === SCREEN_NAMES.TRACK_MANAGE_DISPUTE ||
      screenName === SCREEN_NAMES.APPROVED_CREDIT_REPORT ||
      screenName === SCREEN_NAMES.MATCH_LINE_ITEMS
    ) {
      return this.RestApiService.post_Api(
        'Validations/fetchAllDeductions/v2' + requestURl,
        value
      )
    } else if (
      screenName === SCREEN_NAMES.REMITTANCE_SUMMARY ||
      screenName === SCREEN_NAMES.NEW_REMITTANCE
    ) {
      if (screenName === SCREEN_NAMES.REMITTANCE_SUMMARY) {
        const remitanceReqUrl = requestURl.split('?')
        requestURl = `?filter=false&` + remitanceReqUrl[1]
      } else if (screenName === SCREEN_NAMES.NEW_REMITTANCE) {
        const remitanceReqUrl = requestURl.split('?')
        const payment_status = encodeURIComponent('notin:Payment Posted')
        requestURl =
          `?filter=true&payment_status=${payment_status}&` + remitanceReqUrl[1]
      }
      return this.RestApiService.get_API_New(
        `NewPayments/fetchNewPayments/v2` + requestURl
      )
    } else if (screenName === SCREEN_NAMES.AR_DOCUMENTS) {
      return this.RestApiService.get_API_New('arDocuments/fetch' + requestURl)
    } else if (screenName === SCREEN_NAMES.ALL_DOCUMENTS) {
      return this.RestApiService.get_API_New(
        'documents/all_docs/v2' + requestURl
      )
    } else if (screenName === SCREEN_NAMES.OPEN_DEBIT_MEMO) {
      return this.RestApiService.get_API_New(
        'debitmemo/fetchDebitMemo/v2' + requestURl
      )
    } else if (screenName === SCREEN_NAMES.PROMOTIONS) {
      return this.RestApiService.get_API_New('promotions' + requestURl)
    } else if (screenName === SCREEN_NAMES.LINK_PROMOTIONS) {
      const finalUrl = `promotions${requestURl}${additionalUrlParams || ''}`
      return this.RestApiService.get_API_New(finalUrl)
    } else if (screenName === SCREEN_NAMES.BULK_PROMOTIONS) {
      return this.RestApiService.get_API_New(
        'promotions' + requestURl + `&context=bulk_assign`
      )
    } else if (screenName === SCREEN_NAMES.PROMOTION_HYPERLINK) {
      const finalUrl = `Validations/fetchAllDeductions/v2${requestURl}${additionalUrlParams || ''}`
      return this.RestApiService.post_Api(finalUrl, value)
    } else if (screenName === SCREEN_NAMES.INVOICE_LINE_ITEMS) {
      return this.RestApiService.post_Api(
        'LineItems/fetchInvoiceLineItems/v2' + requestURl,
        value
      )
    }
  }

  getTableDataForPagination_v1(requestURl?, value?, screenName?) {
    if (screenName && screenName === SCREEN_NAMES.INVOICE_LINE_ITEMS) {
      return this.RestApiService.post_Api_Call(
        'LineItems/fetchInvoiceLineItems/v2' + requestURl,
        value
      )
    } else {
      return this.RestApiService.post_Api_Call(
        'Validations/fetchAllDeductions/v2' + requestURl,
        value
      )
    }
  }

  getTableDataForPagination_export(requestURl?, screenName?) {
    if (screenName == SCREEN_NAMES.REMITTANCE_SUMMARY) {
      return this.RestApiService.get_API_Export(
        `NewPayments/fetchNewPayments/v2` + `?filter=false&` + requestURl
      )
    } else if (screenName == SCREEN_NAMES.NEW_REMITTANCE) {
      const payment_status = encodeURIComponent('notin:Payment Posted')
      return this.RestApiService.get_API_Export(
        `NewPayments/fetchNewPayments/v2` +
          `?filter=true&payment_status=${payment_status}&` +
          requestURl
      )
    } else if (screenName == SCREEN_NAMES.ALL_DOCUMENTS) {
      return this.RestApiService.get_API_Export(
        `documents/all_docs/v2` + requestURl
      )
    } else if (screenName == SCREEN_NAMES.AR_DOCUMENTS) {
      return this.RestApiService.get_API_Export(
        `arDocuments/fetch` + requestURl
      )
    } else if (screenName == SCREEN_NAMES.OPEN_DEBIT_MEMO) {
      return this.RestApiService.get_API_Export(
        `debitmemo/fetchDebitMemo/v2` + requestURl
      )
    } else if (screenName === SCREEN_NAMES.PROMOTIONS) {
      return this.RestApiService.get_API_Export(`promotions` + requestURl)
    } else {
      return this.RestApiService.get_API_Export(
        `NewPayments/fetchNewPayments/v2` + requestURl
      )
    }
  }

  updateDeductions(value) {
    return this.RestApiService.post_Api('Validations/updateDeductions', value)
  }

  updatePromotions(value) {
    return this.RestApiService.post_Api('promotions/update', value)
  }

  updateOpenDebitMemos(value) {
    return this.RestApiService.post_Api('debitmemo/update', value)
  }

  updateDisputes(value) {
    return this.RestApiService.post_Api(
      'Validations/updateDisputes',
      value.Body.invoice_data[0]
    )
  }

  updateBulkUpdate(data, query?) {
    if (query) {
      return this.RestApiService.post_Api(
        `Validations/updateBulkDeductions?append=${query}`,
        data
      )
    } else {
      return this.RestApiService.post_Api(
        'Validations/updateBulkDeductions',
        data
      )
    }
  }

  autoApproveDeductions(data) {
    return this.RestApiService.post_Api('Generic/autoapprovedeductions', data)
  }

  createPayment(data) {
    return this.RestApiService.post_Api('Validations/createPayment', data)
  }

  deductionActivity(data) {
    return this.RestApiService.post_Api(
      'Validations/fetchDeductionActivities',
      data
    )
  }

  splitInvoiceNumber(data) {
    return this.RestApiService.post_Api('Validations/splitInvoice', data)
  }
  /* ------------------- Level3 Data API List ------------------------------------*/

  setLevel3Data(data) {
    return this.RestApiService.post_Api(
      'LineItems/createInvoiceLineItems',
      data
    )
  }

  getCreditLineItemsData() {
    return this.RestApiService.get_API_New('Validations/fetchCreditLineItems')
  }

  getCreateLineItemsList(data) {
    return this.RestApiService.get_API_New(
      `Validations/fetchCreditLineItems?id=${data}`
    )
  }

  getCreditDocs() {
    return this.RestApiService.get_API_New(
      `Validations/fetchcreditdocs?file_type=credit_document`
    )
  }

  generateDocs(qs: string | null, data: unknown) {
    return this.RestApiService.post_Api(
      `Validations/generatecreditdocs${qs}`,
      data
    )
  }

  updateItemizationStatus(value) {
    return this.RestApiService.post_Api('NewPayments/updateRemittance', value)
  }

  updateDebit(value) {
    return this.RestApiService.post_Api('NewPayments/updateDebit', value)
  }

  allDocumentUpload(data) {
    return this.RestApiService.post_Api('documents/uploadAllDocuments', data)
  }

  documentUpdate(data) {
    return this.RestApiService.post_Api('documents/updateDocuments', data)
  }

  generateDropdownList(data) {
    return this.RestApiService.get_API_New(
      `Generic/fetchFieldIdsMap?field=${data}`
    )
  }

  getRetailConnectorData() {
    return this.RestApiService.get_API_New(
      'RetailerConnectors/fetchCustomerConnectors'
    )
  }

  createRetailConnect(data) {
    return this.RestApiService.post_Api(
      `RetailerConnectors/InitRetailerConnectorJob?customer_id=${data}`,
      ''
    )
  }

  resendOtp(data) {
    return this.RestApiService.post_Api(
      `RetailerConnectors/resend_OTP?customer_id=${data}`,
      ''
    )
  }

  submitOtp(data) {
    return this.RestApiService.post_Api(`RetailerConnectors/submit_OTP`, data)
  }

  manualLinkDocs(data) {
    return this.RestApiService.post_Api('documents/manualLinkDocs', data)
  }

  getExportStatus(data) {
    return this.RestApiService.post_Api(`Generic/fetchExports/status`, data)
  }

  getExportedFiles(data) {
    return this.RestApiService.get_API_New(
      `Generic/fetchExports?file_type=${data}`
    )
  }
  /* --------------------------------------  Dashboard API LIST  ---------------------------------------------- */
  dashboardSummary(data) {
    return this.RestApiService.get_API_New(`dashboard/basic/summary` + data)
  }

  dashboardProcessingSummary(data) {
    return this.RestApiService.get_API_New(
      `dashboard/basic/processingSummary` + data
    )
  }

  dashboardDisputeSummary(data) {
    return this.RestApiService.get_API_New(
      `dashboard/basic/disputeSummary` + data
    )
  }

  dashboardAutomationSummary(data) {
    return this.RestApiService.get_API_New(
      `dashboard/basic/automationSummary` + data
    )
  }

  dashboardAgingBucket(data) {
    return this.RestApiService.get_API_New(
      `dashboard/basic/agingBuckets` + data
    )
  }

  dashboardDeductionType(data) {
    return this.RestApiService.get_API_New(
      `dashboard/deductions/deduction_type` + data
    )
  }

  dashboardCreditLineItem(data) {
    return this.RestApiService.get_API_New(
      `dashboard/deductions/creditline_item` + data
    )
  }

  dashboardDeductionByCustomer(data) {
    return this.RestApiService.get_API_New(
      `dashboard/deductions/customer` + data
    )
  }

  linkPromotion(data) {
    return this.RestApiService.put_Api(`promotions/link`, data)
  }

  unlinkPromotion(data) {
    return this.RestApiService.put_Api(`promotions/unlink`, data)
  }

  getScreenLevelDetails(value) {
    return this.RestApiService.get_API_New(
      'Generic/UserScreenConfiguration?screen_name=' + value
    )
  }

  fetchLayouts(screenName: string) {
    return this.RestApiService.get_API_New(
      'layouts/fetch?screen_name=' + screenName
    )
  }

  createLayout(data) {
    return this.RestApiService.post_Api('layouts/create', data)
  }

  updateLayout(data) {
    return this.RestApiService.post_Api('layouts/update', data)
  }

  switchLayout(data) {
    return this.RestApiService.post_Api(
      `layouts/switch?id=${data.layoutId}&screen_name=${data.screenName}`,
      null
    )
  }

  deleteLayout(id: number) {
    return this.RestApiService.delete_Api(`layouts/delete?id=${id}`)
  }

  generateCreditSummary(qs: string) {
    return this.RestApiService.get_API_New(`Validations/creditSummary${qs}`)
  }

  fetchDocuments(type, key) {
    return this.RestApiService.get_API_New(
      `documents/fetch?type=` + type + `&key=` + key
    )
  }

  bulkAssignPromotions(data) {
    return this.RestApiService.post_Api(`promotions/bulk_assign`, data)
  }

  getMyDownloads(data, isPolling = false) {
    // For polling: only job_ids are sent
    // For list: page, size, and job_ids are sent
    const queryParams = []

    if (data.page !== undefined && data.size !== undefined) {
      queryParams.push(`page=${data.page}`)
      queryParams.push(`size=${data.size}`)
    }

    if (data.job_ids !== undefined) {
      queryParams.push(`job_ids=${data.job_ids?.join(',')}`)
    }

    // Add polling parameter to prevent global loader when needed
    if (isPolling) {
      queryParams.push('polling=true')
    }

    const queryString =
      queryParams.length > 0 ? '?' + queryParams.join('&') : ''

    return this.RestApiService.get_API_New(`jobs/list${queryString}`)
  }

  createJobs(data) {
    return this.RestApiService.post_Api(`jobs/create`, data)
  }

  retryJob(job_id: string) {
    return this.RestApiService.put_Api(`jobs/${job_id}/retry`, null)
  }

  downloadJob(job_id: string) {
    return this.RestApiService.get_API_New(`jobs/${job_id}/download`)
  }

  fetchTenantList() {
    return this.RestApiService.get_API_New(`user/fetchTenants`)
  }
}
